/* TU Mega Menu · hover-intent open, rail tab switching, keyboard, click-outside, backdrop. */
(() => {
  const HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const instances = new Set();
  let backdrop = null;

  const getBackdrop = () => {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tu-mm-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('click', () => closeAll());
      document.body.appendChild(backdrop);
    }
    return backdrop;
  };
  const anyOpen = () => [...instances].some((i) => i.isOpen);
  const closeAll = (except) => instances.forEach((i) => { if (i !== except) i.close(); });

  class TUMegaMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.tu-mm__panel');
      if (!this.details || !this.summary || !this.panel) return;
      instances.add(this);
      this.tabs = [...this.querySelectorAll('[data-tu-tab]')];
      this.panes = [...this.querySelectorAll('[data-tu-pane]')];

      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.isOpen) { if (!HOVER.matches) this.close(); return; }
        this.open();
      });
      this.summary.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { e.preventDefault(); if (!this.isOpen) this.open(); this.focusFirst(); }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) { e.preventDefault(); e.stopPropagation(); this.close(); this.summary.focus(); }
      });
      this.addEventListener('focusout', (e) => {
        if (this.isOpen && e.relatedTarget && !this.contains(e.relatedTarget)) this.close();
      });
      this.addEventListener('mouseenter', () => this.onEnter());
      this.addEventListener('mouseleave', () => this.onLeave());

      this.tabs.forEach((tab, idx) => {
        tab.addEventListener('mouseenter', () => {
          clearTimeout(this.tabTimer);
          this.tabTimer = setTimeout(() => this.activate(tab.dataset.tuTab), 55);
        });
        tab.addEventListener('focus', () => this.activate(tab.dataset.tuTab));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            const step = e.key === 'ArrowDown' ? 1 : -1;
            this.tabs[(idx + step + this.tabs.length) % this.tabs.length].focus();
          } else if (e.key === 'ArrowRight') {
            const pane = this.activePane();
            const first = pane && pane.querySelector('a');
            if (first) { e.preventDefault(); first.focus(); }
          }
        });
      });
    }
    disconnectedCallback() { instances.delete(this); }
    get isOpen() { return this.details.hasAttribute('open'); }
    onEnter() {
      if (!HOVER.matches || !DESKTOP.matches) return;
      clearTimeout(this.closeTimer);
      this.openTimer = setTimeout(() => this.open(), anyOpen() ? 0 : 80);
    }
    onLeave() {
      if (!HOVER.matches) return;
      clearTimeout(this.openTimer);
      this.closeTimer = setTimeout(() => this.close(), 220);
    }
    open() {
      if (this.isOpen) return;
      closeAll(this);
      this.position();
      this.details.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
      getBackdrop().classList.add('is-on');
      document.documentElement.classList.add('tu-mm-open');
      if (this.tabs.length && !this.activePane()) this.activate(this.tabs[0].dataset.tuTab);
    }
    close() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (!this.isOpen) return;
      this.details.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', 'false');
      if (!anyOpen()) {
        getBackdrop().classList.remove('is-on');
        document.documentElement.classList.remove('tu-mm-open');
      }
    }
    position() {
      const wrap = this.closest('.header-wrapper') || this.closest('header') || this;
      const bottom = Math.max(0, Math.round(wrap.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--tu-mm-top', `${bottom}px`);
      this.panel.style.setProperty('--tu-mm-max', `${Math.max(320, window.innerHeight - bottom - 16)}px`);
    }
    activate(key) {
      this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.tuTab === key));
      this.panes.forEach((p) => {
        const on = p.dataset.tuPane === key;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
    }
    activePane() { return this.panes.find((p) => !p.hidden) || null; }
    focusFirst() { const el = this.tabs[0] || this.panel.querySelector('a'); if (el) el.focus(); }
  }
  if (!customElements.get('tu-mega-menu')) customElements.define('tu-mega-menu', TUMegaMenu);

  document.addEventListener('click', (e) => { if (anyOpen() && !e.target.closest('tu-mega-menu')) closeAll(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    if (anyOpen() && Math.abs(window.scrollY - lastY) > 60) closeAll();
    if (!anyOpen()) lastY = window.scrollY;
  }, { passive: true });
  window.addEventListener('resize', () => { if (!DESKTOP.matches) closeAll(); });
  document.addEventListener('focusin', (e) => {
    if (anyOpen() && e.target.closest && e.target.closest('.header__search-bar, .header__search, details-modal')) closeAll();
  });
})();
